<template>
  <div>
    <p class="login_chose">
      <span :class="choseCode ? 'chose_noActive' : 'chose_active' " @click="choseCode = false">账号登录</span>
      <span :class="choseCode ? 'chose_active' : 'chose_noActive' " @click="choseCode = true">短信登录</span>
    </p>
    <template>

       <!-- 验证码登录 -->
      <el-form :model="userCode"
               v-show="choseCode"
               status-icon
               :rules="rules"
               ref="userCode"
               label-width="100px"
               class="login-ruleForm" >
        <el-form-item prop="phone">
          <el-input type="text" v-model="userCode.phone" autocomplete="off" placeholder="手机号"></el-input>
        </el-form-item>
        <el-form-item prop="code">
          <el-input v-model.number="userCode.code" placeholder="点击获取">
            <template slot="prepend">验证码</template>
            <el-button slot="append" icon="el-icon-message"
                       :disabled="!show" @click="sendSMS">
            </el-button>
          </el-input>
                  <span v-show="count" style="float: right;margin: 12px 52px 0px -49px ;width: 0px">({{count}}s)</span>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="submitForm('userCode')">登录</el-button>
          <span>没有帐号？去<router-link to="/enter/register">注册</router-link></span>
        </el-form-item>
      </el-form>

      <!-- 账户号密码登录 -->
      <el-form :model="userPass"
               v-show="!choseCode"
               status-icon
               :rules="rules"
               ref="userPhone"
               label-width="100px"
               class="login-ruleForm" >
        <el-form-item prop="account">
          <el-input type="text" v-model="userPass.account" autocomplete="off" placeholder="手机号/邮箱"></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input type="password" v-model="userPass.password" placeholder="密码"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="submitForm('userPhone')">登录</el-button>
          <span>没有帐号？去<router-link to="/enter/register">注册</router-link></span>
        </el-form-item>
      </el-form>

      <template style="display: inline">
        <p class="login_other">其他登录方式:</p>
        <a href="https://api.weibo.com/oauth2/authorize?client_id=743815873&response_type=code&redirect_uri=http://43.136.130.200:8888/server/oauth2/weibo/success">
          <img :src=weiboImgUrl class="weiboImg">
        </a>
      </template>

      <!--验证码模态框-->
      <Vcode :show="isShow" @success="successShow" @close="closeShow" />
    </template>


  </div>

</template>

<script>
import Vcode from "vue-puzzle-vcode";
export default {
  name: "Login",
  components:{
    Vcode
  },
  data() {
    //手机号校验规则
    var checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('手机号不能为空'));
      }
      //校验手机号
      var myreg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      setTimeout(() => {
        if (!myreg.test(value)) {
          callback(new Error('请输入正确的手机号'));
        }
        else {
          this.show = true;
          callback();
        }
      }, 1000);
    };
    //验证码校验规则
    var checkCode = (rule, value, callback) => {
      let reg = /^\d{6}$/;
      if(!(reg.test(value))) {
        return callback(new Error('请填写6位数字验证码'));
      }else{
        callback();
      }
    };

    //验证手机号或者邮箱
    var checkAccount = (rule, value, callback) => {
      if(!value){
        return callback(new Error("账号不能为空"))
      }
      var myregPhone = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      var myregEmail = /^([a-zA-Z0-9]+[_|_|.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|_|.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
      setTimeout(() => {
        if (!myregPhone.test(value) && !myregEmail.test(value)) {
          callback(new Error('账号格式不正确'));
        }
        else {
          this.show = true;
          callback();
        }
      }, 1000);
    }

    var checkPass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        callback();
      }
    };
    return {

      choseCode: false, //是否选择验证码登录
      isShow: false, //控制登录时验证码模态框显示与否
      show: false, //控制发送验证码的按钮显示
      count: '', //短信发送按钮不可用倒计时
      weiboImgUrl:require("../../assets/weibo.png"), //微博图标

      userCode: {
        phone: '',
        code: ''
      },
      userPass: {
        account: '',
        password: ''
      },
      rules: {
        account: [
          {validator: checkAccount, trigger: 'blur'}
        ],
        phone: [
          {validator: checkPhone, trigger: 'change'}
        ],
        password:[
          {validator: checkPass, trigger: 'blur'}
        ],
        code:[
          {validator: checkCode, trigger: 'blur'}
        ]
      }
    };
  },
  methods: {

    sendSMS(){
      //校验手机号
      var myreg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      if(!myreg.test(this.userCode.phone)){
        this.$message.error('请填写正确的手机号');
      }else {
        //点击发送短信验证码,开始图形校验
        this.isShow = true
      }

    },
    successShow(){
      //图形验证码验证成功,关闭模态框
      this.isShow = false

      //禁用短信发送按钮
      const TIME_COUNT = 60 //更改倒计时时间

      this.show = false //按钮不可用
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.show = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.show = true;
            clearInterval(this.timer); // 清除定时器
            this.timer = null;
          }
        }, 1000)
      }

      this.axios.post('/login/sendSMS/'+this.userCode.phone+'').then(res=>{
        console.log(this.userCode.phone)
        if(res.data.code === 0){
          //console.log(res.data)
          this.$message(res.data.message)
          this.$message.success('验证码发送成功，请注意查收');
        }else{
          this.$message.error(res.data.message)
        }
      })

    },

    //点击屏幕其他地方,关闭模态框
    closeShow(){
      this.isShow = false
    },

    //点击登录
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {

          var obj = {}
          var fd = new FormData()
          //判断是短信登录或是账号登录
          if(this.choseCode) {
            //验证码登录
            obj = {
              TYPE: 'userCode',
              phone: this.userCode.phone,
              code: this.userCode.code
            }
          }else {
            obj = {
              TYPE: 'userPass',
              account: this.userPass.account,
              password: this.userPass.password
            }
          }
          fd.append("loginInfo",JSON.stringify(obj))

          //向后台发送请求
          this.axios.post("/login/init",fd).then(res => {
            if(res.data.code === 0){
              //登录成功，将返回的token存入，再进首页
              localStorage.setItem("id",res.data.data.id)
              localStorage.setItem("token",res.data.data.token)
              //进入首页
              this.$message.success("登录成功")
              this.$router.replace("/index/buy")
            }else{
              //登录失败，展示失败原因
              this.$message.error(res.data.message)
            }
            this.userPass.password = ''
            this.userPass.account = ''
            this.userCode.phone = ''
            this.userCode.code = ''
          })


        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
}
</script>

<style scoped>

.login_chose{
  padding-top: 12%;
  cursor: pointer;
}

.chose_active {
  margin-right: 6%;
  text-align: center;
  font-family: 幼圆;
  font-size: xx-large;
  font-weight: bolder;

}

.chose_noActive {
  margin-right: 6%;
  text-align: center;
  font-family: 幼圆;
  font-size: x-large;
  font-weight: bold;
  color: rgba(43,43,43,0.48);
}

.login-ruleForm >>> .el-form-item__content {
  margin-left:0px !important;
}

.login-ruleForm >>> .el-input {
  width: 70%;
  margin-top: 3%;
}
.login-ruleForm >>> .el-form-item__error {
  left: 15%;
}

.login_other {
  font-size: medium;
  display: inline;
}
.weiboImg{
  height: 5%;
  width: 5%;
  margin-left: 1%;
}
</style>